/**
 * Detail chip
 *
 * A small muted pill for a secondary value inside a heading or a line, such as an ID after a
 * ticket name, so the value reads apart from the text around it.
 */

import React from 'react';
import Styles from './DetailChip.module.css';

interface DetailChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export const DetailChip: React.FC<DetailChipProps> = ({
  children,
  className,
  ...props
}) => (
  <span
    {...props}
    className={className ? `${Styles.chip} ${className}` : Styles.chip}
  >
    {children}
  </span>
);

export default DetailChip;
